(() => {
  if (!window.HTMLDialogElement) return;
  let dialog, opener, requestedQuantity;
  const root = window.Shopify?.routes?.root || '/';
  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'gp-cart-confirm';
    dialog.setAttribute('aria-labelledby', 'gp-cart-confirm-heading');
    dialog.innerHTML = `<button type="button" class="gp-cart-confirm__close" aria-label="Close">×</button><h2 id="gp-cart-confirm-heading">Added to cart</h2><div class="gp-cart-confirm__items"></div><div class="gp-cart-confirm__actions"><button type="button" class="gp-cart-confirm__continue">Continue shopping</button><a class="gp-cart-confirm__checkout">View cart &amp; checkout</a></div>`;
    dialog.querySelector('a').href = `${root}cart`;
    document.body.append(dialog);
    dialog.querySelectorAll('button').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('gp-cart-confirm-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  }
  function safeImage(value) {
    if (!value || typeof value !== 'string') return '';
    try { const url = new URL(value, location.href); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  }
  function text(tag, className, value) {
    const node = document.createElement(tag); node.className = className; node.textContent = value; return node;
  }
  function added(payload, context = {}) {
    const items = Array.isArray(payload?.items) ? payload.items : [payload];
    if (!items.length || items.some(item => !item?.key || !Number.isFinite(item.price))) return false;
    const quantity = context.quantity ?? requestedQuantity;
    requestedQuantity = null;
    ensureDialog();
    const content = dialog.querySelector('.gp-cart-confirm__items');
    content.replaceChildren();
    const currency = window.Shopify?.currency?.active || 'USD';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' });
    items.forEach(item => {
      const count = items.length === 1 && quantity ? quantity : item.quantity;
      const row = text('div', 'gp-cart-confirm__item', '');
      const fallback = safeImage(item.featured_image?.url || item.image);
      const src = safeImage(item.properties?._customization_image) || fallback;
      if (src) {
        const img = document.createElement('img'); img.src = fallback || src; img.alt = item.product_title || item.title || 'Added product';
        img.width = 160; img.height = 160;
        img.addEventListener('error', () => { if (fallback && img.src !== fallback) img.src = fallback; else img.hidden = true; });
        row.append(img);
        if (src !== fallback && fallback) {
          const preview = new Image();
          preview.onload = () => { img.src = src; };
          preview.src = src;
        }
      }
      const info = text('div', 'gp-cart-confirm__info', '');
      info.append(text('h3', 'gp-cart-confirm__name', item.product_title || item.title));
      (item.options_with_values || []).filter(option => option.value !== 'Default Title' && option.value !== item.product_title).forEach(option => {
        const line = text('p', 'gp-cart-confirm__option', `${option.name}: `);
        line.append(text('strong', '', option.value)); info.append(line);
      });
      const summary = text('div', 'gp-cart-confirm__summary', '');
      summary.append(text('span', '', `Quantity: ${count}`), text('strong', 'gp-cart-confirm__price', money.format((item.final_price ?? item.price) * count / 100)));
      info.append(summary); row.append(info); content.append(row);
    });
    opener = context.opener || document.querySelector('#teeAtcButton') || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('gp-cart-confirm-open', 'gp-cart-confirm-success');
    refreshCartCount();
    return true;
  }
  async function refreshCartCount() {
    // Refresh Dawn's cart count from the actual cart without re-adding anything.
    try {
      const response = await fetch(`${root}?sections=cart-icon-bubble`);
      if (!response.ok) return;
      const sections = await response.json();
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
      const fragment = html.querySelector('.shopify-section');
      const bubble = document.querySelector('#cart-icon-bubble');
      if (fragment && bubble) bubble.innerHTML = fragment.innerHTML;
    } catch { /* Confirmation remains usable if the count refresh fails. */ }
  }
  function install() {
    const api = window.teeinblue || window.TeeInBlue;
    if (!api || api.onItemAdded?.gpCartConfirmation) return;
    const previous = api.onItemAdded;
    const handler = function (...args) {
      try { return typeof previous === 'function' ? previous.apply(this, args) : undefined; }
      finally {
        try { added(args[0]); }
        catch { document.body.classList.remove('gp-cart-confirm-success'); }
      }
    };
    handler.gpCartConfirmation = true;
    api.onItemAdded = handler;
  }
  document.addEventListener('teeinblue-event-before-cart-added', () => {
    install();
    const value = Number(document.querySelector('#teeFormActions .tee-quantity-input')?.value);
    requestedQuantity = Number.isInteger(value) && value > 0 ? value : null;
    document.body.classList.remove('gp-cart-confirm-success');
  });
  document.addEventListener('teeinblue-event-component-injected', install);
  document.addEventListener('teeinblue-event-campaign-loaded', install);
  // Native product forms share the Teeinblue confirmation. Only suppress Dawn's
  // fallback after the dialog opens successfully; failed adds never emit this.
  document.addEventListener('gp:cart-added', event => {
    try {
      if (added(event.detail.item, event.detail)) event.preventDefault();
    } catch { /* Leave Dawn's notification available if the dialog cannot open. */ }
  });
  document.addEventListener('click', event => { if (event.target.closest('#teeAtcButton')) install(); }, true);
  install();
})();
